export const EVENTS = {
  RECORDING_COMPLETED: 'RecordingCompleted',
  RECORDING_TRANSCRIPT_COMPLETED: 'RecordingTranscriptCompleted',
  RECORDING_TRANSCRIPT_FAILED: 'RecordingTranscriptFailed',
  GENERATE_FEEDBACK: 'GenerateFeedback',
  TRANSCRIPT_READY: 'TranscriptReady',
};

export const EVENTS_STEPS = {
  GENERATE_FEEDBACK: 'GenerateFeedback',
  GENERATE_MENTOR_RECOMMENDATION: 'GenerateMentorRecommendation',
  SEND_TRANSCRIPT_COMPLETED_EMAIL: 'SendTranscriptCompletedEmail',
  TRANSCRIPT_PROCESSING: 'TranscriptProcessing',
  CHAT_PROCESSING: 'ChatProcessing',
  UPDATE_GENERATION_FAILED: 'UpdateGenerationFailed',
};

export const RECORDINGS_FILE_TYPES = {
  TRANSCRIPT: 'TRANSCRIPT',
  CHAT: 'CHAT',
  MP4: 'MP4',
  M4A: 'M4A',
  PARTICIPANT: 'participant',
};
